export const tinymceBasicConf = {
    resize: true,
    menubar: false,
    plugins: 'link image code lists paste fullscreen',
    statusbar: false,
    toolbar: ' undo redo | formatselect | bold italic strikethrough | bullist numlist | alignleft aligncenter alignright | link image | pastetext code | fullscreen',    
}
